<template>
  <div
    class="pointer-events-none fixed bottom-0 left-0 right-0 top-0 z-30 overflow-hidden transition-colors duration-300"
    @click="active = !active"
    @keydown.esc="active = false"
    :class="{ 'dial-open pointer-events-auto': active }"
  >
    <div class="pointer-events-auto absolute bottom-8 right-8 z-30">
      <button
        type="button"
        class="button_round p-0"
        @click.stop="active = !active"
        :aria-expanded="active"
        aria-controls="speed-dial-menu"
        aria-label="Kontakt"
      >
        <Transition name="icon-swap" mode="out-in">
          <i
            v-if="!active"
            key="headset"
            class="fa-light fa-headset"
            aria-hidden="true"
          ></i>
          <i
            v-else
            key="xmark"
            class="fa-light fa-xmark"
            aria-hidden="true"
          ></i>
        </Transition>
      </button>
    </div>
    <div
      id="speed-dial-menu"
      class="dial-overlay pointer-events-auto absolute bottom-20 right-8 flex flex-col gap-4 pb-16"
      :inert="!active"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import { trackEvent } from '../utils/tracking';
import { lockScroll, unlockScroll } from '../utils/scrollLock';

const active = ref(false);

// One watcher covers every toggle path (button, overlay click, Esc key).
watch(active, (isOpen) => {
  trackEvent('Speed Dial', isOpen ? 'Open' : 'Close');
  if (isOpen) {
    lockScroll();
  } else {
    unlockScroll();
  }
});
</script>

<style lang="scss">
.dial-overlay {
  visibility: hidden;
  transition: visibility 0s linear 200ms;

  > * {
    opacity: 0;
    transform: translateY(0.75rem);
    transition:
      opacity 200ms ease-out,
      transform 200ms ease-out;
  }
}

.dial-open {
  @apply bg-white/80;

  .dial-overlay {
    visibility: visible;
    transition: visibility 0s linear;

    > * {
      opacity: 1;
      transform: translateY(0);

      @for $i from 1 through 6 {
        &:nth-last-child(#{$i}) {
          transition-delay: #{100 + ($i - 1) * 60}ms;
        }
      }
    }
  }
}

.speed-dial-link {
  @screen md {
    &:hover {
      .button_round,
      .button_rounded {
        @apply border border-black bg-white text-black;
      }
    }
  }
}

.icon-swap-enter-active,
.icon-swap-leave-active {
  transition:
    opacity 200ms ease,
    transform 200ms ease;
}
.icon-swap-enter-from {
  opacity: 0;
  transform: rotate(-45deg) scale(0.6);
}
.icon-swap-leave-to {
  opacity: 0;
  transform: rotate(45deg) scale(0.6);
}
</style>
